import styled from 'styled-components';
import constants from '../../../core/constants';

// MOBILE FIRST
const WrapContent = styled.div.attrs((pr: any) => ({
  isScrollDisabled: pr.isScrollDisabled
}))`
  width: 100%;
  overflow-y: ${(p) => (p.isScrollDisabled ? 'hidden' : 'auto')};
  height: auto;
  background: var(--background-background-UTP);
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  padding-left: 16px;
  padding-right: 16px;
  flex-wrap: nowrap;
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 0%);
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 0%);
    border-radius: 10px;
    background-color: rgb(255 255 255 / 70%);
  }
  &::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b0c0ca;
    border-radius: 10px;
  }

  & .active {
    overflow-y: hidden;
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapHeading = styled.div`
  width: 100%;
  height: 45px;
  background: #ffffff;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b0c0ca;

  label {
    font-family: Lato;
    font-size: 16px;
    font-weight: 900;
    font-stretch: normal;
    color: var(--text-primary);
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapFooter = styled.div`
  width: 100%;
  height: 100vh;
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapPanel = styled.div`
  width: 100%;
  height: 100vh;
  background: var(--background-background-UTP);
  display: flex;
  flex-direction: column;
`;

export { WrapContent, WrapHeading, WrapPanel, WrapFooter };
